export default __webpack_public_path__ + "static/watermarked-samples-dd034786732aac6ccdc00b1148365e4e.jpg";